import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { dogRoutes } from './dog-routes';

@NgModule({
    imports: [RouterModule.forChild(dogRoutes)],
    exports: [RouterModule],
})
export class DogRoutingModule {}
